import {useMutation} from "@tanstack/react-query";

import {restoreSupplierFunctionMutationOptions} from "./restore-supplier-function.mutation-options";

export function useRestoreSupplierFunction() {
  return useMutation(restoreSupplierFunctionMutationOptions());
}
